module.exports = "/_next/static/images/TwilioDeveloperPlan-db2252f49d9397e089120fc2f427b4be.webp";